import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 39 66">
    <g id="Page-1">
      <g id="Outside-Camera">
        <path
          id="Shape"
          style={{ fill: color }}
          d="M16.2,25.2c1.7,0,3.4-0.5,4.9-1.5c1.4-1,2.6-2.3,3.2-4c0.7-1.6,0.8-3.4,0.5-5.1s-1.2-3.3-2.4-4.5
			c-1.2-1.2-2.8-2.1-4.5-2.4c-1.7-0.3-3.5-0.2-5.1,0.5c-1.6,0.7-3,1.8-4,3.2c-1,1.4-1.5,3.2-1.5,4.9c0,2.3,0.9,4.6,2.6,6.2
			C11.6,24.2,13.8,25.2,16.2,25.2z M16.2,9.7c1.3,0,2.6,0.4,3.7,1.1c1.1,0.7,1.9,1.8,2.5,3c0.5,1.2,0.6,2.6,0.4,3.8
			c-0.3,1.3-0.9,2.5-1.8,3.4c-0.9,0.9-2.1,1.6-3.4,1.8c-1.3,0.3-2.6,0.1-3.8-0.4c-1.2-0.5-2.3-1.4-3-2.4c-0.7-1.1-1.1-2.4-1.1-3.7
			c0-1.8,0.7-3.4,1.9-4.7S14.4,9.7,16.2,9.7z"
        />
        <path
          id="Shape_1_"
          style={{ fill: color }}
          d="M16.2,19.9c0.7,0,1.4-0.2,2-0.6c0.6-0.4,1-0.9,1.3-1.6c0.3-0.6,0.3-1.4,0.2-2
			c-0.1-0.7-0.5-1.3-1-1.8c-0.5-0.5-1.1-0.8-1.8-1s-1.4-0.1-2,0.2c-0.6,0.3-1.2,0.7-1.6,1.3c-0.4,0.6-0.6,1.3-0.6,2
			c0,0.9,0.4,1.8,1,2.5C14.3,19.5,15.2,19.9,16.2,19.9z M16.2,14.9c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.4,0.4,0.5,0.6
			c0.1,0.3,0.2,0.5,0.1,0.8c0,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.3-0.7,0.4c-0.3,0.1-0.6,0-0.8-0.1c-0.3-0.1-0.5-0.3-0.6-0.5
			c-0.2-0.2-0.2-0.5-0.3-0.8c0-0.4,0.1-0.7,0.4-1C15.5,15.1,15.8,15,16.2,14.9L16.2,14.9z"
        />
        <path
          id="Path"
          style={{ fill: color }}
          d="M26.8,6.6h0.8c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V4.6c0-0.3-0.1-0.6-0.3-0.8
			c-0.2-0.2-0.5-0.3-0.8-0.3h-0.8c-0.1,0-0.3,0-0.4,0.1S26.1,3.7,26,3.8c-0.1,0.1-0.2,0.2-0.2,0.4c-0.1,0.1-0.1,0.3-0.1,0.4v1
			c0,0.3,0.1,0.5,0.3,0.7C26.2,6.5,26.5,6.6,26.8,6.6z"
        />
        <path
          id="Shape_2_"
          style={{ fill: color }}
          d="M19.8,38.9h4.8c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8v-5.1h5.5c0.3,0,0.6-0.1,0.8-0.3
			c0.2-0.2,0.3-0.5,0.3-0.8V1.1c0-0.3-0.1-0.6-0.3-0.8C31.8,0.1,31.6,0,31.3,0H1.1C0.8,0,0.5,0.1,0.3,0.3C0.1,0.5,0,0.8,0,1.1v30.5
			c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3h5.5v5.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3h5v15.3
			c-0.6,0.7-0.9,1.5-1,2.4c-0.1,0.9,0,1.8,0.4,2.6c0.4,0.8,1,1.5,1.7,2c0.7,0.5,1.6,0.8,2.5,0.8c0.7,0,1.3-0.2,2-0.4
			c0.6-0.3,1.2-0.7,1.6-1.2h16.4v4c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8v-14
			c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3s-0.6,0.1-0.8,0.3s-0.3,0.5-0.3,0.8v4H19.8L19.8,38.9L19.8,38.9z M2.2,2.2h28
			v28.3h-28V2.2z M8.8,32.7h14.8v4H8.8V32.7z M17.6,38.9v13.8c-0.4-0.1-0.9-0.2-1.4-0.2h-0.1c-0.4,0-0.9,0.1-1.3,0.2V38.9L17.6,38.9
			z M16.3,59.7c-0.7,0-1.3-0.3-1.8-0.7c-0.5-0.5-0.7-1.1-0.7-1.8c0-0.4,0.1-0.7,0.2-1c0.1-0.3,0.4-0.6,0.6-0.9
			c0.3-0.3,0.7-0.5,1.1-0.6c0.4-0.1,0.8-0.1,1.2,0.1c0.4,0.1,0.8,0.3,1.1,0.6l0.2,0.2l0.2,0.3c0.3,0.4,0.4,0.9,0.4,1.3
			c0,0.5-0.1,0.9-0.4,1.3c-0.2,0.4-0.5,0.7-0.9,0.9C17.1,59.6,16.7,59.7,16.3,59.7z M36.2,56.4v1.7H20.9V58c0-0.3,0.1-0.5,0.1-0.8
			c0-0.3,0-0.5-0.1-0.8v-0.1H36.2z"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/OutsideCamera.js